<div class="dev-video-viewer">
	@if (mediaUrl) {
		<video
			#videoElement
			[src]="mediaUrl"
			preload="metadata"
			draggable="false"
			[mediaIsPlaying]="isPlaying"
			[autoplay]="isPlaying"
			[loop]="isLooping"
			[volume]="isValidVolume(volume) ? volume : 1"
			(timeupdate)="handleTimeUpdate()"
		></video>
	}
</div>
